import { isMobile, isTablet, isDesktop } from "react-device-detect";

export const showMobile = isMobile && !isTablet && !isDesktop;

export const showMobileBidding = isMobile && !isTablet && !isDesktop;
